import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import LogoImg from "../assets/LogoWhite.png";

function Navbar() {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    return (
        <nav className="fixed top-0 left-0 w-full bg-gray-900/95 backdrop-blur text-white z-50 border-b border-gray-800">
            <div className="max-w-7xl mx-auto px-4 sm:px-6">
                <div className="h-16 flex items-center justify-between">

                    {/* Logo */}
                    <div
                        className="flex items-center gap-3 cursor-pointer group"
                        onClick={() => navigate("/")}
                    >
                        <img
                            src={LogoImg}
                            alt="Machine Repairs Limited logo"
                            className="h-9 w-9"
                        />
                        <span className="font-semibold text-lg tracking-tight group-hover:text-gray-300 transition">
                            Machine Repairs Limited
                        </span>
                    </div>

                    {/* Desktop Actions */}
                    <div className="hidden sm:flex items-center gap-6">
                        <button
                            onClick={() => navigate("/contact")}
                            className="text-sm font-medium text-gray-300 hover:text-white transition"
                        >
                            Request a Quote
                        </button>

                        <button
                            onClick={() => navigate("/breakdown")}
                            className="bg-blue-600 hover:bg-blue-700 transition text-white font-semibold py-2 px-5 rounded-lg text-sm shadow-md"
                        >
                            Report a Breakdown
                        </button>
                    </div>

                    {/* Mobile Menu Button */}
                    <button
                        className="sm:hidden flex items-center"
                        onClick={() => setOpen(!open)}
                    >
                        <div className="space-y-1">
                            <span className="block w-6 h-0.5 bg-white"></span>
                            <span className="block w-6 h-0.5 bg-white"></span>
                            <span className="block w-6 h-0.5 bg-white"></span>
                        </div>
                    </button>
                </div>

                {/* Mobile Dropdown */}
                {open && (
                    <div className="sm:hidden mt-2 pb-4 flex flex-col gap-3 border-t border-gray-800 pt-4">

                        <button
                            onClick={() => {
                                navigate("/contact");
                                setOpen(false);
                            }}
                            className="border border-white/70 hover:bg-white hover:text-gray-900 transition px-4 py-2 rounded-lg font-semibold text-sm"
                        >
                            Request a Quote
                        </button>

                        <button
                            onClick={() => {
                                navigate("/breakdown");
                                setOpen(false);
                            }}
                            className="bg-blue-600 hover:bg-blue-700 transition text-white font-semibold py-2 px-4 rounded-lg text-sm"
                        >
                            Report a Breakdown
                        </button>
                    </div>
                )}
            </div>
        </nav>
    );
}

export default Navbar;